import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
const storageKey = "coachhub-theme";
const isTheme = value => value === "light" || value === "dark";
const systemTheme = () => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

export function ThemeProvider({ children }) {
  const [preference, setPreference] = useState(() => {
    try { const saved = localStorage.getItem(storageKey); return isTheme(saved) ? saved : null; }
    catch { return null; }
  });
  const [system, setSystem] = useState(systemTheme);
  const theme = preference || system;
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
  }, [theme]);
  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const changed = () => setSystem(systemTheme());
    const stored = event => {
      if (event.key === storageKey || event.key === null) setPreference(isTheme(event.newValue) ? event.newValue : null);
    };
    media.addEventListener("change", changed);
    window.addEventListener("storage", stored);
    return () => { media.removeEventListener("change", changed); window.removeEventListener("storage", stored); };
  }, []);
  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setPreference(next);
    try { localStorage.setItem(storageKey, next); } catch { /* Theme still works when storage is unavailable. */ }
  };
  return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
